import type { GetCommentListQuery } from '@schema/cart';

type CommentsItem = NonNullable<GetCommentListQuery['getCommentList']>[number];

type CheckboxItem = CommentsItem & { value: boolean; field: string };
type SelectItem = CommentsItem & { value?: number; field: string };
type OrderChangeItem = Partial<CommentsItem & { value: string; field: string }>;
type OrderHomeItem = Partial<CommentsItem & { value: boolean; field: string }>;

export interface PrepareAllCommentsOptionsReturnType {
  orderOptions: GetCommentListQuery['getCommentList'];
  checkboxes: CheckboxItem[];
  selects: SelectItem[];
  orderChange: OrderChangeItem;
  orderHome: OrderHomeItem;
}

const prepareAllCommentsOptions = ({
  data,
  currentState,
  withoutAddress
}: {
  data: GetCommentListQuery['getCommentList'];
  currentState: PrepareAllCommentsOptionsReturnType;
  withoutAddress?: boolean;
}): PrepareAllCommentsOptionsReturnType => {
  const newState: PrepareAllCommentsOptionsReturnType = {
    orderOptions: data,
    checkboxes: [],
    selects: [],
    orderChange: {},
    orderHome: {}
  };

  if (withoutAddress) {
    newState.orderHome = {
      ...currentState.orderHome,
      value: false
    };

    newState.orderChange = {
      ...currentState.orderChange
    };

    newState.checkboxes = currentState.checkboxes?.map(item => {
      if (item.attachment === 'address') {
        return {
          ...item,
          value: false
        };
      }

      return item;
    });

    newState.selects = currentState.selects?.map(item => {
      const requiredValue: {
        value?: number;
      } = {};
      if (item.required === 1) {
        requiredValue.value = item.options[0]?.id;
      }

      if (item.attachment === 'address') {
        return {
          ...item,
          ...requiredValue
        };
      }

      return item;
    });
  } else {
    data?.forEach(item => {
      if (item.id === 16) {
        newState.orderChange = {
          ...item,
          value: '',
          field: ''
        };
      } else if (item.id === 37) {
        newState.orderHome = {
          ...item,
          value: false,
          field: ''
        };
      } else if (item.type === 'checkbox') {
        newState.checkboxes = [
          ...newState.checkboxes,
          {
            ...item,
            value: false,
            field: ''
          }
        ];
      } else if (item.type === 'select') {
        const requiredValue: {
          value?: number;
        } = {};

        if (item.required === 1) {
          requiredValue.value = item.options[0]?.id;
        }
        newState.selects = [
          ...newState.selects,
          {
            ...item,
            ...requiredValue,
            field: ''
          }
        ];
      }
    });
  }
  return newState;
};

export default prepareAllCommentsOptions;
